/**
 * @generated SignedSource<<4529cc0089dc80119109e0900171e0ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type appNavigationTab_businessTabs$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabOld_Tab">;
  readonly " $fragmentType": "appNavigationTab_businessTabs";
};
export type appNavigationTab_businessTabs$key = {
  readonly " $data"?: appNavigationTab_businessTabs$data;
  readonly " $fragmentSpreads": FragmentRefs<"appNavigationTab_businessTabs">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "appNavigationTab_businessTabs",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_navigationKitTabOld_Tab"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "f67e752c2cd890a3fdfe9249c174c9d7";

export default node;
